export const Users = [
  {
    id: "610c8b587db84236e99bd788",
    profilePicture: "person/demo.jpg",
    username: "Lazir Pascual",
  },
  {
    id: "61171a992dbbcb00237a960d",
    profilePicture: "person/8.jpeg",
    username: "Kristen Dunn",
  },
  {
    id: "61171dbd2dbbcb00237a9757",
    profilePicture: "person/4.jpeg",
    username: "Dora Hawks",
  },
  {
    id: "610c875cc24ab434ebc1ae1b",
    profilePicture: "person/2.jpeg",
    username: "Mark Mathews",
  },
];
